export const FIXED_SECTION_NAME = "Fixos";
